import styled from 'styled-components'

export const Wrapper = styled.div`
  margin-top: 10px;
`

export const RankingWrapper = styled.div`
  display: flex;
  gap: 1rem;
  max-width: 100vw;
  padding-top: 30px;
  overflow-x: auto;

  .empty {
    margin: 0 auto;
  }
`

export const Item = styled.div`
  position: relative;
  border: 1px solid #cbcbcb;
  flex: none;
  width: 257px;

  .rank {
    position: absolute;
    top: -20px;
    left: 0px;
    width: 40px;
    height: 40px;
    display: grid;
    place-content: center;
    z-index: 1;
  }
`

export const Tabs = styled.div`
  display: inline-grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.5rem;
  margin-left: 1.5em;
`

export const Tab = styled.button`
  padding: 8px 16px;
  background-color: transparent;
  color: ${({ theme }) => theme.success};
  border: 1px solid;
  border-radius: 100vmax;
  cursor: pointer;

  &.active {
    color: #fff;
    background-color: ${({ theme }) => theme.success};
  }
`
